import React from "react";

// react-super-responsive-table collapses each <td> into its own "row" below
// ~640px (SuperResponsiveTableStyle.css), but only labels a cell if it finds
// a child `.tdBefore` — plain <td>s (as here) fall back to a labelless
// stack, i.e. seven bare values with no indication which is Source vs. Price.
// `headers` mirrors the same array AlertListingTable already passes to <Th>.
const HEADERS_DEFAULT = [
  "Source",
  "Date",
  "Product",
  "Title",
  "Reference",
  "Price",
  "Country",
];

const AlertListingItem = ({ item, headers = HEADERS_DEFAULT }) => {
  return (
    <>
      <tr
        key={item.listing_id}
        className={`alert-listing-item rc-alisting-row${
          item?.underpriced ? " rc-alisting-row--underpriced" : ""
        }`}
        onClick={() => window.open(item?.link, "_blank")}
      >
        <td>
          <span className="tdBefore">{headers[0]}</span>
          {item?.source}&nbsp;
        </td>
        <td>
          <span className="tdBefore">{headers[1]}</span>
          {item?.date?.substr(0, 10)}&nbsp;
        </td>
        <td>
          <span className="tdBefore">{headers[2]}</span>
          {item?.image_link && item.image_link !== "N/A" ? (
            <img
              src={item.image_link}
              alt="Product"
              className="rc-alisting-row__image"
            />
          ) : (
            <div className="rc-alisting-row__image-placeholder" />
          )}
        </td>
        <td>
          <span className="tdBefore">{headers[3]}</span>
          {item?.title}&nbsp;
        </td>
        <td>
          <span className="tdBefore">{headers[4]}</span>
          {item?.reference}&nbsp;
        </td>
        <td>
          <span className="tdBefore">{headers[5]}</span>
          {item?.price}&nbsp;
        </td>
        <td>
          <span className="tdBefore">{headers[6]}</span>
          {item?.country}&nbsp;
        </td>
      </tr>
    </>
  );
};

export default AlertListingItem;
